import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Logo from '../../../../assets/logo.svg?react';
import { BlockInput, Button, Icon, JustifyContents, Alignment } from 'tacho-ui';
import style from './style.module.scss';
interface LoginFormProps {
    pending: boolean;
    loginError: string;
    onSubmitLogin: () => void;
}

export function LoginForm(props: LoginFormProps): JSX.Element {
    const { formatMessage } = useIntl();

    return (
        <BlockInput className={`flexColumnFullHeightContainer ${style.loginContainer}`}>
            <div className={`${style.loginFormWrapper}`}>
                <div className="d-flex gap-4 align-items-end">
                    <h2>
                        <FormattedMessage id="loginFormTitle" />
                    </h2>
                    <div className={style.logoContainer}>
                        <Logo className={style.customLogo} />
                    </div>
                </div>

                <div className={style.innerLoginFormWrapper}>
                    <Button
                        icon={Icon.Login}
                        loading={props.pending}
                        className={style.buttonFullWidth}
                        justify={JustifyContents.center}
                        align={Alignment.center}
                        text={formatMessage({ id: 'loginFormSignIn' })}
                        onClick={props.onSubmitLogin}
                    />
                    <span className={style.formError}>{props.loginError && formatMessage({ id: props.loginError })}</span>
                </div>
            </div>
        </BlockInput>
    );
}
